import React, { useContext } from 'react'
import styles from './EventAgendaModal.module.scss'
import { EventAgendaContext } from '@/component/Context/EventAgendaContext'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'
import Icon from '@/component/Primitive/Icon'
import Type from '@/component/Primitive/Type'
import { SpeakerThumbnail, ButtonGroup } from '@/component/Primitive/Events'
import moment from 'moment'

export const EventAgendaModal = () => {
  const { handleCloseModal, eventAgendaModalItem } = useContext(
    EventAgendaContext
  )
  if (!eventAgendaModalItem) return null
  const {
    name,
    sessionType,
    speakers,
    visibility,
    description,
    location,
    startDate,
    registerButtonClassName,
    registerAction,
    time,
    sponsor
  } = eventAgendaModalItem

  const sponsorLogo = sponsor?.images?.logo_1x1_320?.[0]
  const formattedStartDate = moment(startDate).format('MMM D, YYYY')
  const dateRange = `${formattedStartDate} | ${time}`
  const buttonAction = registerAction || {}
  const buttonGroup = [
    {
      ...buttonAction,
      label: buttonAction?.labelOverride || 'Register',
      type: 'action',
      action: 'register',
      buttonClassName: registerButtonClassName
    }
  ]

  return (
    <div className={styles.EventAgendaModal}>
      <Container center gutter size="wide" className={styles.ModalWrapper}>
        <Container center size="medium" className={styles.ModalInner}>
          <Stack gap="medium">
            <div className={styles.ModalInnerTop}>
              <Stack gap="medium">
                <Type
                  className={styles.SessionType}
                  as="span"
                  weight="regular"
                  size={['body3', 'body3']}
                >
                  {sessionType}
                </Type>

                <Type
                  as="h1"
                  size={['heading5', 'heading3']}
                  weight="bold"
                  className={styles.Name}
                >
                  {name}
                </Type>
              </Stack>

              {
                sponsorLogo && <img
                  className={styles.ModalInnerImage}
                  src={sponsorLogo?.url}
                  alt={sponsorLogo?.caption}
                  width="150"
                  height="150"
                />
              }
            </div>

            <div className={styles.InfoRow}>
              <Type
                as="p"
                weight="medium"
                size={['body4', 'body4']}
                className={styles.DateRange}
              >
                <Icon width="20" type="calendar" className={styles.Calendar} />
                {dateRange}
              </Type>
              <Type
                as="p"
                weight="medium"
                size={['body4', 'body4']}
                className={styles.Location}
              >
                <Icon width="14" type="map-pin" className={styles.Pin} />
                {location}
              </Type>
            </div>
            <Type size={['body4', 'body3']} className={styles.Description}>
              <p dangerouslySetInnerHTML={{ __html: description }} />
            </Type>
            {!!speakers.length && (
              <>
                <Type
                  as="h1"
                  size={['body3', 'body1']}
                  weight="bold"
                  className={styles.SpeakersTitle}
                >
                  Speakers
                </Type>
                <div className={styles.Speakers}>
                  {speakers.map((speaker, i) => (
                    <SpeakerThumbnail key={i} {...speaker} />
                  ))}
                </div>
              </>
            )}
            <div className={styles.Buttons}>
              {!!buttonGroup?.length &&
                !['public--no-register', 'private'].includes(visibility) && (
                  <ButtonGroup group={buttonGroup} />
                )}
            </div>
          </Stack>
        </Container>
        <button
          className={styles.CloseButton}
          onClick={() => handleCloseModal()}
        >
          <Icon width="20" type="close" className={styles.Cross} />
        </button>
      </Container>
      <button className={styles.Overlay} onClick={() => handleCloseModal()} />
    </div>
  )
}

EventAgendaModal.propTypes = {}
